import { useEffect, useRef, useState } from 'react';

const useCountdown = (totalSeconds, onComplete) => {
  const [secondsLeft, setSecondsLeft] = useState(totalSeconds);
  const onCompleteRef = useRef(onComplete);
  const hasCompletedRef = useRef(false);

  onCompleteRef.current = onComplete;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(intervalId);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (secondsLeft !== 0 || hasCompletedRef.current || !onCompleteRef.current) return;
    hasCompletedRef.current = true;
    onCompleteRef.current();
  }, [secondsLeft]);

  return secondsLeft;
};

export default useCountdown;
